<template>
  <div class="about">
    <BossHeader/>
    <vSidebar/>
    <div class="content-box" :class="{ 'content-collapse': collapse }">
      <BossTags/>
      <div class="content">
        <transition name="fade-transform" appear mode="out-in">
          <keep-alive :include="tagsList" :exclude="noCacheList">
            <router-view :key="key"></router-view>
          </keep-alive>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import BossHeader from "../boss-header";
import vSidebar from "../sider-bar";
import BossTags from "../boss-tags";

const { mapActions } = Vuex;
export default {
  components: {
    BossHeader,
    vSidebar,
    BossTags
  },
  mounted() {
    this.getEnumByKeys();
  },
  computed: {
    noCacheList() {
      return this.$store.state.noCacheList
    },
    tagsList() {
      return this.$store.state.tagsList.map(item => item.name)
    },
    collapse() {
      return this.$store.state.collapse
    },
    key() {
      return this.$route.fullPath
    }
  },
  methods: {
    ...mapActions([
      'getEnumByKeys'
    ])
  }
}
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all .5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

</style>
